import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLenis } from "@/hooks/useLenis";
import { OfferBanner } from "@/components/site/OfferBanner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Calculator } from "@/components/site/Calculator";
import { Packages } from "@/components/site/Packages";
import { Testimonials } from "@/components/site/Testimonials";
import { Manifesto } from "@/components/site/Manifesto";
import { Marquee } from "@/components/site/Marquee";
import { Gallery } from "@/components/site/Gallery";
import { Footer } from "@/components/site/Footer";
import { StickyCTA } from "@/components/site/StickyCTA";

export default function Home() {
  useLenis();
  const [packages, setPackages] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [summary, setSummary] = useState(null);
  const [siteImages, setSiteImages] = useState({});

  useEffect(() => {
    Promise.all([api.get("/packages"), api.get("/gallery"), api.get("/reviews"), api.get("/google-summary"), api.get("/settings/site-images")])
      .then(([p, g, r, s, i]) => {
        setPackages(p.data);
        setGallery(g.data);
        setReviews(r.data);
        setSummary(s.data);
        setSiteImages(i.data || {});
      })
      .catch((e) => console.error("load failed", e));
  }, []);

  const scrollTo = (sel) => document.querySelector(sel)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="min-h-screen bg-background">
      <OfferBanner />
      <Navbar />
      <main>
        <Hero onCalc={() => scrollTo("#calculator")} summary={summary} images={siteImages} />
        <Services images={siteImages} />
        <Calculator />
        {packages.length > 0 && <Packages packages={packages} />}
        {reviews.length > 0 && <Testimonials reviews={reviews} summary={summary} />}
        <Manifesto />
        <Marquee />
        {gallery.length > 0 && <Gallery images={gallery} />}
        <Footer />
      </main>
      <StickyCTA />
    </div>
  );
}
